// pages
import {
  Dashboard,
  DashboardAdmin,
  TicketInbox,
  Agents,
  FormAgents,
  Departments,
  FormDepartments,
  Groups,
  FormGroups,
  Emails,
  FormEmails,
  Banlist,
  FormBanlist,
  TicketDepartment,
  SubTicket,
  FormTicket,
  Templates,
  ViewTemplates,
  FormTemplates,
  Emailsettings,
  Diagnostics,
  Helptopics,
  FormHelptopics,
  Slapans,
  FormSlapans,
  Priorities,
  FormPriorities,
  Ticket,
  Autoresponse,
  Alertandnotice,
  Status,
  FormStatus,
  Ratings,
  FormRatings,
  Closeticket,
  Company,
  Cron,
  SettingNotif,
  Debugging,
  Logs,
  CannedResponses,
  KBSettings,
  KBFormCategory,
  KBAllCategory,
  KBFormArticle,
  KBAllArticle,
  ReportHelpTopic,
  User,
  Organization,
  Notifications,
  FormCanned,
  Profile,
  FormProfile,
  ChangePassword,
  FormUser,
  FormOrganization,
  ViewUser,
  TicketDetail,
  SpamPotential,
  SpamLimit,
  ViewUserAgent,
  NotificationsUpdate,
  TicketMyticket,
  TicketUnassigned,
  TicketOverdue,
  TicketTrash,
  TicketSpam,
  TicketSearch,
} from "pages";

// icons
import { AiFillFolderOpen, AiFillSetting } from "react-icons/ai";

import {
  BsCalendarXFill,
  BsFillHeartPulseFill,
  BsFillTrash3Fill,
  BsPeopleFill,
} from "react-icons/bs";
import { BsCircle } from "react-icons/bs";
import { ImBlocked, ImSearch } from "react-icons/im";
import {
  FaEnvelope,
  FaUnlink,
  FaList,
  FaEdit,
  FaCog,
  FaUser,
  FaSitemap,
  FaObjectGroup,
  FaBan,
  FaReply,
  FaAt,
  FaPlus,
  FaFileAlt,
  FaClock,
  FaAsterisk,
  FaReplyAll,
  FaBell,
  FaPlusSquare,
  FaStar,
  FaBuilding,
  FaHourglass,
  FaBug,
  FaWindowClose,
  FaMailBulk,
} from "react-icons/fa";
import { HiTicket } from "react-icons/hi";
import { IoDocumentTextSharp } from "react-icons/io5";
import { MdDashboard } from "react-icons/md";
import { TbPackages } from "react-icons/tb";
import { convertToSlug } from "utils/convertToSlug";
import { decryptArrayLocalStorage } from "utils/decryptArrayLocalStorage";

const DataDepartement = decryptArrayLocalStorage("tnemtrapedbnc") ?? [];
const Permission = decryptArrayLocalStorage("noissimrepedc") ?? [];
const permissionReport = Permission.includes("view_menu_report") ?? false;
const permissionTools = Permission.includes("view_menu_tools") ?? false;
var hiddenInboxTicket = true;
var hiddenSearchTicket = true;
if (Permission.includes("can_view_inbox")) {
  hiddenInboxTicket = false;
}
if (Permission.includes("can_view_search_ticket")) {
  hiddenSearchTicket = false;
}

export const menuAgents = [
  {
    level: 1,
    title: "Dashboard",
    name: "dashboard",
    path: "dashboard/agent",
    icon: <MdDashboard />,
    element: <Dashboard />,
    sub: [],
  },
  {
    level: 1,
    title: "Search Ticket",
    name: "Search Ticket",
    path: "search_ticket",
    hidden: hiddenSearchTicket,
    type: "ticket",
    icon: <ImSearch />,
    element: <TicketSearch />,
    sub: [],
  },

  {
    level: 1,
    title: "Tickets",
    name: "tickets",
    path: "tickets",
    icon: null,
    element: null,
    sub: [
      {
        level: 2,
        title: "Inbox",
        name: "inbox",
        path: "inbox",
        hidden: hiddenInboxTicket,
        type: "ticket", //type ticket menu can have badge
        icon: <FaEnvelope />,
        element: <TicketInbox />,
        sub: [],
      },
      {
        level: 2,
        title: "My Tickets",
        name: "mytickets",
        path: "mytickets",
        type: "ticket",
        icon: <HiTicket />,
        element: <TicketMyticket />,
        sub: [],
      },
      {
        level: 2,
        title: "Unassigned",
        name: "unassigned",
        path: "unassigned",
        type: "ticket",
        icon: <FaUnlink />,
        element: <TicketUnassigned />,
        sub: [],
      },
      {
        level: 2,
        title: "Overdue",
        name: "overdue",
        path: "overdue",
        type: "ticket",
        icon: <BsCalendarXFill />,
        element: <TicketOverdue />,
        sub: [],
      },
      {
        level: 2,
        title: "Trash",
        name: "trash",
        path: "trash",
        type: "ticket",
        icon: <BsFillTrash3Fill />,
        element: <TicketTrash />,
        sub: [],
      },
      {
        level: 2,
        title: "Spam",
        name: "spam",
        path: "spam",
        type: "ticket",
        icon: <ImBlocked />,
        element: <TicketSpam />,
        sub: [],
      },
    ],
  },
  DataDepartement && {
    level: 1,
    title: "Departments",
    name: "departments",
    path: "departments",
    icon: null,
    element: null,
    sub: DataDepartement.map((item, index) => ({
      level: 2,
      title: item.name,
      name: convertToSlug(item.name),
      path: convertToSlug(item.name),
      icon: <AiFillFolderOpen />,
      element: null,
      sub: [
        {
          level: 3,
          title: "Closed",
          name: "closed",
          path: "closed",
          idDept: item.id,
          idStatus: 3,
          type: "ticket", //type ticket menu can have badge
          icon: <BsCircle />,
          element: <TicketDepartment IDdepartment={item.id} type={"closed"} />,
        },
        {
          level: 3,
          title: "Open",
          name: "open",
          path: "open",
          idDept: item.id,
          idStatus: 1,
          type: "ticket",
          icon: <BsCircle />,
          element: <TicketDepartment IDdepartment={item.id} type={"open"} />,
        },
        {
          level: 3,
          title: "Resolved",
          name: "resolved",
          path: "resolved",
          idDept: item.id,
          idStatus: 2,
          type: "ticket",
          icon: <BsCircle />,
          element: (
            <TicketDepartment IDdepartment={item.id} type={"resolved"} />
          ),
        },
      ],
    })),
  },
  {
    level: 1,
    title: "Profile",
    name: "profile",
    path: "dashboard/profile",
    icon: null,
    hidden: true,
    element: null,
    sub: [
      {
        level: 2,
        title: "Information Profile",
        name: "informationprofile",
        path: "informationprofile",
        icon: null,
        hidden: true,
        element: <Profile />,
        sub: [],
      },
      {
        level: 2,
        title: "Form Profile",
        name: "formprofile",
        path: "informationprofile/formprofile",
        icon: null,
        hidden: true,
        element: <FormProfile />,
        sub: [],
      },
      {
        level: 2,
        title: "Change Password",
        name: "changepassword",
        path: "informationprofile/changepassword",
        icon: null,
        hidden: true,
        element: <ChangePassword />,
        sub: [],
      },
    ],
  },
];

export const menuAdmin = [
  {
    level: 1,
    title: "Dashboard Admin",
    name: "dashboardadmin",
    path: "administrator/dashboard/admin",
    icon: <MdDashboard />,
    element: <DashboardAdmin />,
    sub: [],
  },
  {
    level: 1,
    title: "Settings",
    name: "Administrator",
    path: "administrator",
    icon: null,
    element: null,
    sub: [
      {
        level: 2,
        title: "Knowledge Base",
        name: "knowledgebase",
        path: "knowledgebase",
        icon: <FaAsterisk />,
        element: null,
        sub: [
          {
            level: 3,
            title: "Category",
            name: "category",
            path: "category",
            icon: <FaList />,
            element: <KBAllCategory />,
          },
          {
            level: 3,
            title: "Add Category",
            name: "addcategory",
            path: "category/addcategory",
            icon: <BsCircle />,
            element: <KBFormCategory typeForm={"create"} />,
            hidden: true,
          },
          {
            level: 3,
            title: "Edit Category",
            name: "editcategory",
            path: "category/editcategory",
            icon: <BsCircle />,
            element: <KBFormCategory typeForm={"edit"} />,
            hidden: true,
          },
          {
            level: 3,
            title: "Question & Answer",
            name: "question",
            path: "question",
            icon: <FaEdit />,
            element: <KBAllArticle />,
          },
          {
            level: 3,
            title: "Add Article",
            name: "addarticle",
            path: "question/addarticle",
            icon: <BsCircle />,
            hidden: true,
            element: <KBFormArticle typeForm={"create"} />,
          },
          {
            level: 3,
            title: "Edit Article",
            name: "editarticle",
            path: "question/editarticle",
            hidden: true,
            icon: <BsCircle />,
            element: <KBFormArticle typeForm={"edit"} />,
          },
          {
            level: 3,
            title: "Setting",
            name: "setting",
            path: "setting",
            icon: <FaCog />,
            element: <KBSettings />,
            sub: [],
          },
        ],
      },
      {
        level: 2,
        title: "Staff",
        name: "staff",
        path: "staff",
        icon: <BsPeopleFill />,
        element: null,
        sub: [
          {
            level: 3,
            title: "Agents",
            name: "agents",
            path: "agents",
            icon: <FaUser />,
            element: <Agents />,
          },
          {
            level: 3,
            title: "Form Agents",
            name: "agentscreate",
            path: "agents/create",
            element: <FormAgents typeForm={"create"} />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Agents Edit",
            name: "agentsedit",
            path: "agents/edit",
            element: <FormAgents typeForm={"edit"} />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Agents View",
            name: "agentsview",
            path: "agents/view",
            element: <ViewUserAgent />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Departments",
            name: "departments",
            path: "departments",
            icon: <FaSitemap />,
            element: <Departments />,
          },
          {
            level: 3,
            title: "Form Departments",
            name: "departmentscreate",
            path: "departments/create",
            element: <FormDepartments typeForm={"create"} />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Departments Edit",
            name: "departmentsedit",
            path: "departments/edit",
            element: <FormDepartments typeForm={"edit"} />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Groups",
            name: "groups",
            path: "groups",
            icon: <FaObjectGroup />,
            element: <Groups />,
          },
          {
            level: 3,
            title: "Form Groups Create",
            name: "groupscreate",
            path: "groups/create",
            element: <FormGroups typeForm="create" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Groups Edit",
            name: "groupsedit",
            path: "groups/edit",
            element: <FormGroups typeForm="edit" />,
            sub: [],
            hidden: true,
          },
        ],
      },
      {
        level: 2,
        title: "Email",
        name: "email",
        path: "email",
        icon: <FaEnvelope />,
        element: null,
        sub: [
          {
            level: 3,
            title: "Emails",
            name: "Emails",
            path: "emails",
            icon: <FaEnvelope />,
            element: <Emails />,
          },
          {
            level: 3,
            title: "Form Emails",
            name: "emailscreate",
            path: "emails/create",
            element: <FormEmails typeForm="create" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Emails Edit",
            name: "emailsedit",
            path: "emails/edit",
            element: <FormEmails typeForm="edit" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Ban Lists",
            name: "banlists",
            path: "banlists",
            icon: <FaBan />,
            element: <Banlist />,
          },
          {
            level: 3,
            title: "Form Banlist",
            name: "banlistcreate",
            path: "banlists/create",
            element: <FormBanlist typeForm="create" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Banlist Edit",
            name: "banlistedit",
            path: "banlists/edit",
            element: <FormBanlist typeForm="edit" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Spam Potential",
            name: "spampotential",
            path: "spampotential",
            icon: <FaWindowClose />,
            element: <SpamPotential />,
            sub: [],
          },
          {
            level: 3,
            title: "Spam Limit",
            name: "spamlimit",
            path: "spamlimit",
            icon: <FaMailBulk />,
            element: <SpamLimit />,
            sub: [],
          },
          {
            level: 3,
            title: "Templates",
            name: "templates",
            path: "templates",
            icon: <FaReply />,
            element: <Templates />,
          },
          {
            level: 3,
            title: "View Templates",
            name: "viewtemplates",
            path: "templates/view",
            element: <ViewTemplates />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Templates Edit",
            name: "templatesedit",
            path: "templates/view/edit",
            element: <FormTemplates typeForm="edit" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Templates Create",
            name: "templatescreate",
            path: "templates/view/create",
            element: <FormTemplates typeForm="create" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Email Settings",
            name: "emailsettings",
            path: "emailsettings",
            icon: <FaAt />,
            element: <Emailsettings />,
          },
          // {
          //   level: 3,
          //   title: "Queues",
          //   name: "queues",
          //   path: "queues",
          //   icon: <FaUpload />,
          //   element: <Queues />,
          // },
          {
            level: 3,
            title: "Diagnostics",
            name: "diagnostics",
            path: "diagnostics",
            icon: <FaPlus />,
            element: <Diagnostics />,
          },
        ],
      },
      {
        level: 2,
        title: "Manage",
        name: "manage",
        path: "manage",
        icon: <TbPackages />,
        element: null,
        sub: [
          {
            level: 3,
            title: "Help Topics",
            name: "helptopics",
            path: "helptopics",
            hidden: true,
            icon: <FaFileAlt />,
            element: <Helptopics />,
          },
          {
            level: 3,
            title: "Form Help Topics",
            name: "helptopicscreate",
            path: "helptopics/create",
            element: <FormHelptopics typeForm="create" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Help Topics Edit",
            name: "helptopicsedit",
            path: "helptopics/edit",
            element: <FormHelptopics typeForm="edit" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "SLA Plans",
            name: "slaplans",
            path: "slaplans",
            icon: <FaClock />,
            element: <Slapans />,
          },
          {
            level: 3,
            title: "Form SLA Plans",
            name: "slaplanscreate",
            path: "slaplans/create",
            element: <FormSlapans typeForm="create" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form SLA Plans Edit",
            name: "slaplansedit",
            path: "slaplans/edit",
            element: <FormSlapans typeForm="edit" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Priorities",
            name: "priorities",
            path: "priorities",
            icon: <FaAsterisk />,
            element: <Priorities />,
          },
          {
            level: 3,
            title: "Form Priorities",
            name: "prioritiescreate",
            path: "priorities/create",
            element: <FormPriorities typeForm="create" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Priorities Edit",
            name: "prioritiesedit",
            path: "priorities/edit",
            element: <FormPriorities typeForm="edit" />,
            sub: [],
            hidden: true,
          },
          // {
          //   level: 3,
          //   title: "URLs",
          //   name: "urls",
          //   path: "urls",
          //   icon: <FaServer />,
          //   element: <Urls />,
          // },
        ],
      },
      {
        level: 2,
        title: "Tickets",
        name: "tickets",
        path: "tickets",
        icon: <HiTicket />,
        element: null,
        sub: [
          {
            level: 3,
            title: "Ticket",
            name: "ticket",
            path: "ticket",
            icon: <FaFileAlt />,
            element: <Ticket />,
          },
          {
            level: 3,
            title: "Auto Response",
            name: "autoresponse",
            path: "autoresponse",
            icon: <FaReplyAll />,
            element: <Autoresponse />,
          },
          {
            level: 3,
            title: "Alert & Notices",
            name: "alertnotices",
            path: "alertnotices",
            icon: <FaBell />,
            element: <Alertandnotice />,
          },
          {
            level: 3,
            title: "Status",
            name: "status",
            path: "status",
            icon: <FaPlusSquare />,
            element: <Status />,
          },
          {
            level: 3,
            title: "Form Status Edit",
            name: "statusedit",
            path: "status/edit",
            element: <FormStatus typeForm="edit" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Ratings",
            name: "ratings",
            path: "ratings",
            icon: <FaStar />,
            element: <Ratings />,
          },
          {
            level: 3,
            title: "Form Ratings",
            name: "ratingscreate",
            path: "ratings/create",
            element: <FormRatings typeForm="create" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Form Ratings Edit",
            name: "ratingsedit",
            path: "ratings/edit",
            element: <FormRatings typeForm="edit" />,
            sub: [],
            hidden: true,
          },
          {
            level: 3,
            title: "Close Ticket Workflow",
            name: "closeticketworkflow",
            path: "closeticketworkflow",
            icon: <FaSitemap />,
            element: <Closeticket />,
          },
        ],
      },
      {
        level: 2,
        title: "Setting",
        name: "setting",
        path: "setting",
        icon: <AiFillSetting />,
        element: null,
        sub: [
          {
            level: 3,
            title: "Company",
            name: "company",
            path: "company",
            icon: <FaBuilding />,
            element: <Company />,
          },

          {
            level: 3,
            title: "Cron",
            name: "cron",
            path: "cron",
            icon: <FaHourglass />,
            element: <Cron />,
          },

          {
            level: 3,
            title: "Notifications",
            name: "notifications",
            path: "notifications",
            icon: <FaBell />,
            element: <SettingNotif />,
          },
        ],
      },
      {
        level: 2,
        title: "Error Logs & Debugging",
        name: "errorlogsdebugging",
        path: "errorlogsdebugging",
        icon: <BsFillHeartPulseFill />,
        element: null,
        sub: [
          {
            level: 3,
            title: "Debugging Options",
            name: "debuggingoptions",
            path: "debuggingoptions",
            icon: <FaBug />,
            element: <Debugging />,
          },
        ],
      },
      {
        level: 2,
        title: "Logs",
        name: "logs",
        path: "logs",
        icon: <IoDocumentTextSharp />,
        element: <Logs />,
        sub: [],
      },
    ],
  },
];

export const menuNav = [
  {
    level: 1,
    title: "Users",
    name: "users",
    path: "users",
    element: null,
    sub: [
      {
        level: 2,
        title: "User Directory",
        name: "userdirectory",
        path: "userdirectory",
        element: <User />,
        sub: [],
      },
      {
        level: 2,
        title: "View User",
        name: "viewuser",
        path: "userdirectory/view",
        element: <ViewUser />,
        hidden: true,
        sub: [],
      },
      {
        level: 2,
        title: "Organizations",
        name: "organizations",
        path: "organizations",
        element: <Organization />,
        hidden: true,
        sub: [],
      },
      {
        level: 2,
        title: "Create User",
        name: "userdirectory",
        path: "userdirectory/createuser",
        element: <FormUser typeForm={"create"} />,
        hidden: true,
        sub: [],
      },
      {
        level: 2,
        title: "Edit User",
        name: "userdirectory",
        path: "userdirectory/edituser",
        element: <FormUser typeForm={"edit"} />,
        hidden: true,
        sub: [],
      },
      {
        level: 2,
        title: "Create Organizations",
        name: "createorganizations",
        path: "organizations/createorganizations",
        element: <FormOrganization typeForm={"create"} />,
        hidden: true,
        sub: [],
      },
      {
        level: 2,
        title: "Edit Organizations",
        name: "editorganizations",
        path: "organizations/editorganizations",
        element: <FormOrganization typeForm={"edit"} />,
        hidden: true,
        sub: [],
      },
    ],
  },
  {
    level: 1,
    title: "Tickets",
    name: "tickets",
    path: "tickets",
    element: null,
    sub: [
      {
        level: 2,
        title: "Answered",
        name: "answered",
        path: "answered",
        element: <SubTicket typeSubTicket={"answered"} />,
        sub: [],
      },
      {
        level: 2,
        title: "Unanswered",
        name: "unanswered",
        path: "unanswered",
        element: <SubTicket typeSubTicket={"unanswered"} />,
        sub: [],
      },
      {
        level: 2,
        title: "Assigned",
        name: "assigned",
        path: "assigned",
        element: <SubTicket typeSubTicket={"assigned"} />,
        sub: [],
      },
      {
        level: 2,
        title: "Closed",
        name: "closed",
        path: "closed",
        element: <SubTicket typeSubTicket={"closed"} />,
        sub: [],
      },
      {
        level: 2,
        title: "New Ticket",
        name: "newticket",
        path: "newticket",
        element: <FormTicket />,
        sub: [],
      },
      {
        level: 2,
        title: "Ticket Detail",
        name: "ticketdetail",
        path: "ticketdetail",
        element: <TicketDetail />,
        hidden: true,
        sub: [],
      },
    ],
  },
  {
    level: 1,
    title: "Tools",
    name: "tools",
    path: "tools",
    element: null,
    hidden: permissionTools,
    sub: [
      {
        level: 2,
        title: "Canned Responses",
        name: "cannedresponses",
        path: "cannedresponses",
        element: <CannedResponses />,
        sub: [],
      },
      {
        level: 2,
        title: "Create Canned",
        name: "createcanned",
        path: "cannedresponses/formcanned",
        element: <FormCanned />,
        sub: [],
        hidden: true,
      },
    ],
  },
  {
    level: 1,
    title: "Reports",
    name: "reports",
    path: "reports",
    hidden: permissionReport,
    element: <ReportHelpTopic />,
    sub: [],
  },
  {
    level: 1,
    title: "Notifications",
    name: "notifications",
    path: "notifications",
    element: <Notifications />,
    hidden: true,
    sub: [],
  },
  {
    level: 1,
    title: "Notifications Update",
    name: "notificationsUpdate",
    path: "notificationsupdate",
    element: <NotificationsUpdate />,
    hidden: true,
    sub: [],
  },
];
